module.exports = "<button md-effect type=\"button\" class=\"btn btn-sm btn-info\" uib-tooltip=\"Reenviar correo de confirmación\" \n  ng-click=\"$ctrl.reenviarCorreo()\">\n  <i class=\"fa fa-share-square-o\"></i>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/usuarios/reenviar-confirmacion/reconfirmacion.html
// module id = 731
// module chunks = 0